import { IOfferDiscount, IVoucherDiscount } from "../models/catalogue";
import { ILocation, ILocationLatLon, ILocationZip } from "../models/location";
import type { Dinero } from "./money";

/**
 * ReactDOM.findDOMNode returns an Element or a TextNode. This type-guard determines
 * if the returned value is an Element or not.
 */
export const isElement = (
    node: Element | Text | string | null,
): node is Element => {
    if (!node) {
        return false;
    }
    return (node as Element).querySelector !== undefined;
};

/**
 * Type gate to differentiate offer discounts from voucher discounts
 */
export const discountIsVoucher = (
    discount: IVoucherDiscount | IOfferDiscount,
): discount is IVoucherDiscount => {
    const voucherDiscount = discount as IVoucherDiscount;
    return !!(voucherDiscount.voucher && voucherDiscount.voucher.code);
};

export const isDinero = (value: unknown): value is Dinero => {
    return (
        typeof value === "object" &&
        value !== null &&
        "calculator" in value &&
        "toJSON" in value &&
        typeof value.toJSON === "function"
    );
};

export const isZipLocation = (loc: ILocation): loc is ILocationZip => {
    return (loc as ILocationZip).zip !== undefined;
};

export const isLatLngLocation = (loc: ILocation): loc is ILocationLatLon => {
    return (loc as ILocationLatLon).lat !== undefined;
};

export const hasKeys = <T>(
    state: unknown,
    keys: Array<keyof T>,
): state is T => {
    return (
        state !== null &&
        typeof state === "object" &&
        keys.every((key) => key in state)
    );
};
